module.exports = __webpack_public_path__ + "static/media/logo-white.8a3e803b.png";